import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import React from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const WPBlock = ({
  index,
  innerBlocks
}) => /* @__PURE__ */ jsx(React.Fragment, { children: generateBlockList({
  blocks: innerBlocks
}) }, index);
WPBlock.propTypes = {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
};
export {
  WPBlock as default
};
